import throttle from 'lodash/throttle'

class Reviews {
  constructor (el) {
    this.el = el
    this.contentObserver = null
    const yotpoMain = this.el.querySelector('.js-yotpo-main')
    const reviewStars = yotpoMain?.querySelectorAll(
      '.yotpo-reviews .yotpo-review'
    )
    if (reviewStars) {
      this.cloneStars(reviewStars)
      const label = yotpoMain.querySelector('.reviews-qa-labels-container .reviews-qa-label')
      if (label) {
        this.removeReviewsText(label)
      }
    }

    const config = { attributes: true, childList: true, subtree: true }
    const callback = throttle((mutations) => {
      mutations.forEach(({ type }) => {
        if (type === 'childList' || type === 'subtree') {
          const reviewStars = yotpoMain?.querySelectorAll(
            '.yotpo-reviews .yotpo-review'
          )
          const label = yotpoMain.querySelector('.reviews-qa-labels-container .reviews-qa-label')
          if (reviewStars) {
            this.cloneStars(reviewStars)
          }
          if (label) {
            this.removeReviewsText(label)
          }
        }
      })
    }, 1250)

    this.contentObserver = new MutationObserver(callback)
    this.contentObserver.observe(yotpoMain, config)

  }

  removeReviewsText (label) {
    if (label.textContent.split(' ').length === 2) {
      label.textContent = label.textContent.split(' ')[0]
    }
  }

  countFilledStars (starsEl) {
    if (!starsEl) return 0

    const filledStars = starsEl.querySelectorAll('.yotpo-icon-star')
    return filledStars.length
  }

  cloneStars (reviews) {
    reviews.forEach((review) => {
      const stars = review.querySelector('.yotpo-review-stars')
      const main = review.querySelector('.yotpo-main')

      if (stars && main) {
        const newStars = stars.cloneNode(true)
        const newStarsCount = this.countFilledStars(newStars)
        const oldStars = main.querySelector('.yotpo-review-stars')
        const oldStarsCount = this.countFilledStars(oldStars)

        if (!oldStars) {
          main.prepend(newStars)
        } else if (newStarsCount !== oldStarsCount) {
          main.replaceChild(newStars, oldStars)
        }
      }
    })
  }
}

export default el => new Reviews(el)